// @ts-nocheck
import React, { useMemo, useState } from "react";

const FALLBACK_COUNTRIES = ["US", "GB", "CA", "PK", "AU", "DE", "FR", "IT", "ES", "JP", "IN", "BR"];

export default function LocationSelector({
  location,
  countryCode = "US",
  onCountryChange,
  onUseLocation,
  onSetLocation,
  onToggleSavedOnly,
  isLocating,
  error,
  savedOnly = false,
  savedEventsCount = 0,
  isAuthenticated = false,
}) {
  const [input, setInput] = useState("");
  const countryOptions = useMemo(() => {
    let displayNames = null;
    if (typeof Intl !== "undefined" && Intl.DisplayNames) {
      try {
        displayNames = new Intl.DisplayNames(["en"], { type: "region" });
      } catch (_error) {
        displayNames = null;
      }
    }

    let supportedValues = FALLBACK_COUNTRIES;
    if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
      try {
        const values = Intl.supportedValuesOf("region");
        if (Array.isArray(values) && values.length > 0) {
          supportedValues = values;
        }
      } catch (_error) {
        supportedValues = FALLBACK_COUNTRIES;
      }
    }

    return supportedValues
      .map((code) => ({
        code,
        label: displayNames ? displayNames.of(code) || code : code,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!input.trim()) {
      return;
    }
    onSetLocation(input.trim());
  };

  return (
    <div className="events-location">
      <div className="location-header">
        <div className="location-header-top">
          <div>
            <h2>Local Card Events</h2>
            <p>Trade cards in person. Meet collectors near you.</p>
          </div>
          <button
            type="button"
            className={`saved-events-toggle ${savedOnly ? "active" : ""}`}
            onClick={onToggleSavedOnly}
            aria-pressed={savedOnly}
            title={isAuthenticated ? "Show saved events" : "Login to view saved events"}
          >
            Saved Events ({savedEventsCount})
          </button>
        </div>
        <span className="events-chip">Trading enabled at events</span>
      </div>

      {location ? (
        <div className="location-active">
          <div>
            <div className="location-label">Events within {location.radius} miles</div>
            <div className="location-value">{location.label}</div>
          </div>
          <button className="link-button" type="button" onClick={() => onSetLocation("")}
            aria-label="Change location">
            Change
          </button>
        </div>
      ) : (
        <div className="location-actions">
          <button className="btn-primary" type="button" onClick={onUseLocation} disabled={isLocating}>
            {isLocating ? "Locating..." : "Use my location"}
          </button>
          <form className="location-input" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter postal code"
              value={input}
              onChange={(event) => setInput(event.target.value.slice(0, 16))}
              aria-label="Enter postal code"
            />
            <select
              value={countryCode}
              onChange={(event) => onCountryChange?.(event.target.value)}
              aria-label="Select country"
            >
              {countryOptions.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.label}
                </option>
              ))}
            </select>
            <button className="btn-secondary" type="submit">Set</button>
          </form>
        </div>
      )}

      {error && <div className="location-error">{error}</div>}
    </div>
  );
}
